export default __webpack_public_path__ + "static/media/NEO NX 110_1.7eeefc55.webp";